'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    NonOpenableFilterChip: ()=>NonOpenableFilterChip_NonOpenableFilterChip
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
const external_CdnIcon_index_cjs_namespaceObject = require("../../CdnIcon/index.cjs");
const external_Image_index_cjs_namespaceObject = require("../../Image/index.cjs");
const Span_cjs_namespaceObject = require("../../Text/Span.cjs");
const external_FilterChip_variants_cjs_namespaceObject = require("../FilterChip.variants.cjs");
const NonOpenableFilterChip_NonOpenableFilterChip = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(function({ label, className, onClick, selected = false, onSelectionChange, iconLeft, count, id, name, value, helperText, showCheckIcon = true, filterType = 'checkbox', customNode, favicon, faviconAlt, labelImage, labelImageAlt, ...props }, ref) {
    const [selectedState, setSelectedState] = (0, external_react_namespaceObject.useState)(selected);
    const isControlled = void 0 !== onSelectionChange;
    const handleClick = (event)=>{
        if (isControlled) onSelectionChange(!selectedState);
        else setSelectedState(!selectedState);
        onClick?.(event);
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        setSelectedState(selected);
    }, [
        selected
    ]);
    const { labelTextSlot, helperTextSlot, containerSlot, iconLeftSlot, checkIconSlot, iconRightSlot, countSlot, checkboxSlot, faviconSlot, faviconImg, labelImageSlot } = (0, external_FilterChip_variants_cjs_namespaceObject.filterChipVariants)({
        ...props,
        disabled: props.disabled,
        hasIconLeft: Boolean(iconLeft),
        selectedState,
        hasCount: void 0 !== count && count >= 0,
        showCheckIcon
    });
    const classes = (0, index_cjs_namespaceObject.cn)(containerSlot(), className);
    const iconSize = 'tile' === props.type ? '20' : '18';
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("button", {
                ref: ref,
                className: classes,
                onClick: handleClick,
                disabled: props.disabled,
                "aria-selected": selectedState,
                ...(0, index_cjs_namespaceObject.cleanProps)(props, [
                    'selected',
                    'type',
                    'elevated',
                    'emphasis',
                    'opens'
                ]),
                children: [
                    showCheckIcon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                        className: (0, index_cjs_namespaceObject.cn)(checkIconSlot()),
                        iconName: 'check',
                        size: iconSize
                    }),
                    customNode ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "flex w-full",
                        children: customNode
                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            iconLeft && !favicon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                                className: (0, index_cjs_namespaceObject.cn)(iconLeftSlot()),
                                iconName: iconLeft,
                                size: iconSize
                            }),
                            favicon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Span_cjs_namespaceObject.Span, {
                                className: faviconSlot(),
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                                    src: favicon,
                                    alt: faviconAlt || '',
                                    className: faviconImg()
                                })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                        className: labelTextSlot(),
                                        children: labelImage ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Image_index_cjs_namespaceObject.Image, {
                                            src: labelImage,
                                            alt: labelImageAlt || '',
                                            className: labelImageSlot()
                                        }) : label
                                    }),
                                    'tile' === props.type && helperText && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                        className: helperTextSlot(),
                                        children: helperText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                                className: countSlot(),
                                children: void 0 !== count ? `(${count})` : null
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: 'hidden [.openable-filter-chip_&]:inline-flex',
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_CdnIcon_index_cjs_namespaceObject.CdnIcon, {
                            className: iconRightSlot(),
                            iconName: 'arrow_drop_down',
                            size: iconSize
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("input", {
                className: checkboxSlot(),
                type: filterType,
                role: filterType,
                id: id,
                name: name,
                "data-testid": id,
                disabled: props.disabled,
                checked: selectedState,
                onChange: handleClick,
                value: value,
                tabIndex: -1
            })
        ]
    });
});
exports.NonOpenableFilterChip = __webpack_exports__.NonOpenableFilterChip;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "NonOpenableFilterChip"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
